import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
//import { UsuariosForm } from './usuarios-form';
import { Table } from "../../../elements/table";
import { DevicesForm } from './devices-form';
//import { UsuariosFilter } from './usuarios-filter';

export const Devices = () => {
    const { open, close } = useDrawer();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>({});
    const [query, setQuery] = useState<any>(new URLSearchParams(filters));

    const handleNewAction = () => {
        open('usuarios.form.new-item', <DevicesForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleShowDevice = (item: any) => {
        navigate(`/devices/${item.id}`);
    };

    /*   const handleFilters = () => {
          open(
              'common.filter.title',
              <UsuariosFilter close={close} doFilter={doFilter} item={filters} />
          );
      }; */

    const doFilter = (filters: any) => {
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        close();
    };

    return (
        <>

            <PageBody
                newAction={handleNewAction}
                title={'common.form-label.devices'}
                newActionTitle={'common.form-title.new'}
            //filterAction={handleFilters}
            //filters={filters}
            >
                <Table
                    path="/fleet/tracker-devices/"
                    deletePath="/fleet/tracker-devices/"
                    query={query}
                    callBeforeDrawerClosed={handleClose}
                    Form={DevicesForm}
                    onShow={handleShowDevice}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'IMEI',
                            label: 'IMEI',
                        }, {
                            key: 'phone_number',
                            label: 'common.form-label.phone',
                        },
                        {
                            key: 'vehicle',
                            subKey: 'plate',
                            label: 'common.form-label.matricula-vehiculo'
                        },
                    ]}
                />
            </PageBody>
        </>
    );
};